export default __webpack_public_path__ + "static/media/portfolio.b4710655.PNG";